import { render, staticRenderFns } from "./ot-breadcrumbs.vue?vue&type=template&id=04299654&scoped=true&"
import script from "./ot-breadcrumbs.vue?vue&type=script&lang=ts&"
export * from "./ot-breadcrumbs.vue?vue&type=script&lang=ts&"
import style0 from "./ot-breadcrumbs.vue?vue&type=style&index=0&id=04299654&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04299654",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBreadcrumbsItem } from 'vuetify/lib/components/VBreadcrumbs';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBreadcrumbs,VBreadcrumbsItem,VIcon})
